import React from 'react';
import ExploitationHeader from './header/exploitation.header';
import './page-layout.style.scss';

const PageLayout = ({ title, children }) => {
  return (
    <div className="page-layout">
      <div className="page-layout__header">
        {title && <h1 className="page-layout__title">{title}</h1>}
        <ExploitationHeader />
      </div>
      <div className="page-layout__content">{children}</div>
    </div>
  );
};

export default PageLayout;
